export default {"src":"/_next/static/media/dm.73be4c01.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};